import {createSelector} from "@reduxjs/toolkit";

export const vehiclesSelector = (store) => store.vehicles;

export const selectVehicleError = createSelector([vehiclesSelector], (vehicles) => vehicles && vehicles.error);

/** Full list from API (active + archived). Use for historical views where a route still references an archived vehicle. */
export const selectAllVehicles = createSelector(
  [vehiclesSelector],
  (vehicles) => (vehicles && vehicles.vehicles) || []
);

export const selectAllActiveVehicles = createSelector([vehiclesSelector], (vehicles) => vehicles && vehicles.vehicles && vehicles.vehicles.filter((vehicle) => vehicle.status === 'active'));
